import { toggleSidebar } from "../../api_utils/geditor_utils";
import { Link } from 'react-router-dom';
function TopNav() {
  const handleClick = () => {
    toggleSidebar(false);
  };
  return (
    <nav className="navbar navbar-light">
      <div className="container">
     
        <button
        
        >
           <Link  to='/pages'>
                Back to Page Settings
            </Link>
         
        </button>
        <div className="panel__devices"></div>
        <div className="panel__editor"></div>
        <div className="panel__basic-actions"></div>
      </div>
    </nav>
  );
}

export default TopNav;
